import React from "react";
import { Outlet } from "react-router-dom";
//import TopBar from "../../components/TopBar/TopBar";
import TopBar from "../../components/TopBar/TopBar";
import './DashboardPage.css'

const DashboardPage = () => {

  return (
    <>
      <TopBar />
      <Outlet />
    </>
  );
};

export default DashboardPage;
